;(function() {
"use strict";

angular.module("app.config", [])

.constant("ENV", {
	"name": "production",
	"version": "0.0.0",
	"html5Mode": true,
	"apiEndpoint": "https://rest.domain.com"
})

;
}());
